import Axios from '../axios'
import appConfig from '../../../app.config'
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { TFunction } from 'i18next'
import { logError } from '../../../shared'
import { ICreditBalance } from '../../interfaces/i-api-creaditCard'

async function getCreditCardDataService(customerId: string, t: TFunction) {
	const response = await Axios.get<ICreditBalance>(
		`${appConfig.customerDataBaseUrl}/api/creditcard/creditcard?customerId=${customerId}&includeBlockedAuthorizations=true&enablePartialContentResponse=true`,
		await getHeadersWithJwtToken(),
	)
		.then((result) => {
			return result.data as ICreditBalance
		})
		.catch((err) => {
			logError(err)
			if (err.response?.status === 404) {
				throw new Error(t('NoAccounts'))
			} else {
				throw err
			}
		})
	return response as ICreditBalance
}

export default getCreditCardDataService
